import React from 'react';
import { useTranslation } from 'react-i18next';
import { Values } from '@lib/interfaces/form';
import Form from '@lib/components/ReactHookForm/FormContainer';
import Modal from '@lib/components/Modal/Modal';
import { GetLoadOptions } from '@lib/components/Select/types';
import { getSitesLoadOptions as getSitesLoadOptionsFn } from 'utils/fetch/searchLists/sitesSearchList';
import { FilterGroupingEnum } from 'graphql-common';
import { MonitoringEntity } from 'routes/Dashboard/Monitoring/enums';
import { getSectorsLoadOptions as getSectorsLoadOptionsFn } from 'utils/fetch/searchLists/sectorsSearchList';
import useFilterFields, {
  DASHBOARD_MONITORING_ADD_FILTER_BY_ENTITY_FORM_EMPTY_VALUES as defaultValues,
} from '../utils/useFilterByEntitlyFields';
import MonitoringFilterByEntityAddActions from './MonitoringFilterByEntityAddActions';
import { UseQueryResult } from '../utils/useQueries';

export interface FormProps {
  ids: string[];
  isOpen: boolean;
  monitoringEntity: MonitoringEntity;
  onCancel: () => void;
  onClose: () => void;
  onSubmit: (values: Values) => void;
  useQueriesResult: UseQueryResult;
}

export default function MonitoringFilterByEntityAddModalForm(props: FormProps) {
  const {
    isOpen,
    onCancel,
    onClose,
    onSubmit,
    useQueriesResult,
    ids,
    monitoringEntity,
  } = props;
  const { fetchSitesSearchListLazyQuery, fetchSectorsSearchListLazyQuery } =
    useQueriesResult;
  const { t } = useTranslation();

  const additionalFilters = [
    {
      id: {
        grouping: FilterGroupingEnum.Or,
        predicate: {
          notIn: ids,
        },
      },
    },
  ];
  const getSitesLoadOptions: GetLoadOptions = () =>
    getSitesLoadOptionsFn(fetchSitesSearchListLazyQuery, additionalFilters);
  const getSectorsLoadOptions: GetLoadOptions = () =>
    getSectorsLoadOptionsFn(fetchSectorsSearchListLazyQuery, additionalFilters);

  const fields = useFilterFields({
    getSitesLoadOptions,
    getSectorsLoadOptions,
    monitoringEntity,
  });

  let modalCaption = '';
  if (monitoringEntity === MonitoringEntity.Site) {
    modalCaption = t('monitoring-sites-ranges');
  } else if (monitoringEntity === MonitoringEntity.Sector) {
    modalCaption = t('monitoring-sectors-ranges');
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} caption={modalCaption}>
      <Form
        defaultValues={defaultValues}
        actionsComponent={MonitoringFilterByEntityAddActions}
        actionsComponentProps={{ onCancel }}
        fields={fields}
        formId="monitoring-filter-entity-add-form"
        onSubmit={onSubmit}
      />
    </Modal>
  );
}
